const PUBLIC_PATHS = ['/', '/login'];

let onSessionExpired = null;

export function registerSessionExpiredHandler(handler) {
  onSessionExpired = handler;
}

export function clearAuthSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  onSessionExpired?.();
}

export function redirectIfProtectedPath() {
  if (!PUBLIC_PATHS.includes(window.location.pathname)) {
    window.location.href = '/';
  }
}
